import {apiRequest} from "@helpers/query/apiRequest";
import {GRAPHHOPPER_API_URL} from "@constants/config";
import {serialize} from "@helpers/query/serialize";
import {IDataGraphhopper, IPropsGetRouteGraphhopper} from "@containers/graphhopper/types";
import {normalizeGraphhopperFormat} from "@containers/graphhopper/api/helpers";

export const getRouteGraphhopper = async (params: IPropsGetRouteGraphhopper, onError?: (error: any) => void): Promise<IDataGraphhopper> => {
    const {points, ...rest} = params;

    const pointStr = points.map((latLng) => `point=${latLng.lat},${latLng.lng}`)?.join('&')

    const url = `${GRAPHHOPPER_API_URL}/route?${pointStr}&` + serialize({
        points_encoded: false,
        instructions: params.instructions ?? false,
        vehicle: params.vehicle ?? 'car',
        type: params.type ?? 'json',
    })

    const data = await apiRequest<IDataGraphhopper>({
        url,
        options: {
            method: 'get'
        },
        onError
    })
    return normalizeGraphhopperFormat(data)
}